const monthNames = [
    'Января',
    'Февраля',
    'Марта',
    'Апреля',
    'Мая',
    'Июня',
    'Июля',
    'Августа',
    'Сентября',
    'Октября',
    'Ноября',
    'Декабря',
];

/**
 * @returns {Function} Формирование даты из timestamp
 *
 * @param {Number} timestamp Время в секундах
 * @param {Boolean} short
 * @param isDateObject
 */
export default (timestamp, short = false, isDateObject = false) => {
    let date;
    if (isDateObject) {
        date = timestamp;
    } else {
        date = new Date();
        date.setTime(parseInt(timestamp) * 1000);
    }
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate().toString().padStart(2, '0');

    var limiter = short ? '.' : ' ';

    const monthStr = short
        ? (month + 1).toString().padStart(2, '0')
        : monthNames[month].toLowerCase();

    return `${day}${limiter}${monthStr}${limiter}${year}`;
};
